export enum Gender {
    Male = 1,
    Female = 2,
}

export enum DigitalWalletStatus {
    Active = 1,
    NotActive = 2,
    NotEstablished = 3,
}

export enum DocCategory {
    PurchaseAdvanceInvoice = 1,
    CustomerInvoice = 2,
    CustomerPaymentReceipt = 3,
    OrderCancellationRequest = 4,
    SalesOrderConfirmation = 5,
    Other = 6,
}

export enum OrderStatus {
    None = 0,
    OK = 1,
    CN = 2,
    RQ = 3,
    Unknown = 4,
    Quote = 5,
    Error = 6,
}

export enum OrderType {
    WithoutSubsidy = 0,
    WithSubsidy = 1,
}

export enum HomePagePeriod {
    ByMonth = 1,
    ByYear = 2,
    ByWeek = 3,
}

export enum FormTypes {
    FunDay = 1,
    GroupOrder = 2,
}

export enum TransactionType {
    Loading = 1,
    Usage = 2,
    BalanceReset = 3,
    Freeze = 4,
    CancelFreeze = 5,
    Refund = 6,
    UpdExpireDate = 7,
}

export enum ServiceType {
    HotelService = 2,
    FlightService = 4,
    GeneralService = 6,
}

export enum VisitorsTypes {
    EmployeesOnly = 1,
    IncludingCouples = 2,
    Families = 3,
}

export enum MealTypes {
    None = 0,
    RefreshmentsOnArrival = 1,
    FullBreakfast = 2,
    RefreshmentsOnTheWay = 4,
    Lunch = 8,
    Dinner = 16,
}

export enum FormMessageTypes {
    MessageOne = 1,
    MessageTwo = 2,
    MessageThree = 3,
}

export enum NatureFunDayTypes {
    None = 0,
    Challenges = 1,
    Trip = 2,
    Combined = 4,
}

export enum HotelLevelTypes {
    None = 0,
    ThreeStars = 1,
    FourStars = 2,
    FiveStars = 4,
}

export enum StayingRequestTypes {
    None = 0,
    WeekendOneNight = 1,
    WeekendTwoNight = 2,
    MidweekOneNight = 4,
    MidweekTwoNights = 8,
    MidweekThreeNights = 16,
    MidweekFourNights = 32,
}

export enum SpecialRequestStayTypes {
    None = 0,
    FirstNight = 1,
    SecondNight = 2,
    ThirdNight = 4,
    FourthNight = 8,
}

export enum AdditionDrinksTypes {
    None = 0,
    DrinksOne = 1,
    DrinksTwo = 2,
    DrinksThree = 4,
    DrinksFour = 8,
}

export enum ArtistPerformanceTypes {
    InsideHotel = 1,
    OutsideHotel = 2,
}

export enum AccountingDocType {
    Invoice = 1,
    Receipt = 2,
}

export enum MessageSourceDestinationType {
    BO = 1,
    APP = 2,
    B2C = 3,
}

export enum DirectionType {
    Import = 1,
    Export = 2,
    WalletLoading = 3,
}

export enum ContentType {
    ImportOfEmployees = 1,
    ExportOfEmployees = 2,
    ExportBudget = 3,
    LoadForWallets = 4,
    ExportAccountingDocs = 5,
    ExportOrders = 6,
}

export enum WalletSystem {
    Lalun = 1,
    Tmura = 2,
}

export enum CredentialState {
    Pending = -1,
    Success = 0,
    Error = 1,
}

export enum EmployeeActionType {
    SetStatusActive = 1,
    SetStatusInactive = 2,
}
